import { useState } from "react";
import CheckIcon from "@material-ui/icons/Check";
import { Button, useRefresh, useNotify, useUnselectAll } from "react-admin";

import { firestore } from "../../../init/firebase";
import { applyTimestamps } from "../../../utils/funcs";

const EnableClientButton = ({ selectedIds }) => {
  const refresh = useRefresh();
  const notify = useNotify();
  const unselectAll = useUnselectAll();
  const [loading, setLoading] = useState();
  const enableClient = async () => {
    try {
      setLoading(true);
      const batch = firestore.batch();
      Array.isArray(selectedIds) &&
        selectedIds.forEach((id) => {
          batch.update(
            firestore.collection("clients").doc(id),
            applyTimestamps({
              data: {
                disabled: false,
              },
              isUpdate: true,
            })
          );
        });
      await batch.commit();
      notify("Clients have been updated", "success");
      unselectAll("clients");
      refresh();
      setLoading(false);
    } catch (ex) {
      console.log(ex.message);
      notify("Error on enabling clients", "error");
      refresh();
      setLoading(false);
    }
  };

  return (
    <Button label="Enable" disabled={loading} onClick={enableClient}>
      <CheckIcon />
    </Button>
  );
};

export default EnableClientButton;
